import { format } from 'date-fns';

import { Accordion } from '../../../../../common/Accordion';
import { Icon } from '../../../../../common/Icon';
import { formatDuration } from '../../../../../utils/dateUtils';
import { GroupedMeetingData } from '../../../hooks/useSprintTimeline';
import { getTimeInTeamTimezone } from '../../../utils/timelineUtils';
import { getTotalMeetingDuration } from '../helpers';

import { TimelineItem } from './TimelineItem';

export function MeetingsAccordion({
  groupedMeetings,
}: {
  groupedMeetings: GroupedMeetingData;
}): JSX.Element {
  const hasMeetings = Object.keys(groupedMeetings || {}).length > 0;

  return (
    <Accordion
      title={
        <div className="flex items-center gap-2">
          <Icon name="meeting" className="text-[#FA8C16]" />
          Meetings {getTotalMeetingDuration(groupedMeetings)}
        </div>
      }
    >
      {!hasMeetings ? (
        <div className="text-gray-500 text-sm py-4 text-center">
          No meetings attended for this period
        </div>
      ) : (
        Object.keys(groupedMeetings || {})
          .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
          .map((dateKey, idx, arr) => {
            const meetingsForDate = groupedMeetings[dateKey];
            if (!meetingsForDate) return null;
            return (
              <TimelineItem
                key={dateKey}
                date={dateKey}
                timePeriod={groupedMeetings[dateKey].reduce(
                  (total, meeting) => total + meeting.duration,
                  0,
                )}
                showLine={idx < arr.length - 1}
              >
                <div className="ml-6 mt-2 bg-white border border-gray-200 rounded-lg p-4 text-sm text-gray-700 shadow-sm">
                  {meetingsForDate.map((meeting, index) => (
                    <div
                      key={meeting.id}
                      className={
                        index < meetingsForDate.length - 1 ? 'mb-2' : ''
                      }
                    >
                      {format(
                        getTimeInTeamTimezone(meeting.startTime),
                        'h:mm a',
                      )}
                      {' : '}
                      {meeting.title} (
                      {formatDuration(
                        (getTimeInTeamTimezone(meeting.endTime).getTime() -
                          getTimeInTeamTimezone(meeting.startTime).getTime()) /
                          (1000 * 60 * 60),
                      )}
                      )
                    </div>
                  ))}
                </div>
              </TimelineItem>
            );
          })
      )}
    </Accordion>
  );
}
